const tableOfContent = () => {
    const tocItems = document.querySelectorAll('.content-list li');

    const tocHeader = document.querySelector('.toc-header');
    const tocContent = document.querySelector('.toc-content');

    if (!tocHeader || !tocContent) return;
    // Toggle functionality for TOC header
    tocHeader.addEventListener('click', function() {
        const isCollapsed = tocContent.classList.contains('collapsed');
        
        if (isCollapsed) {
            // Expand
            tocContent.classList.remove('collapsed');
            tocContent.classList.add('expanded');
            tocHeader.classList.remove('collapsed');
        } else {
            // Collapse
            tocContent.classList.remove('expanded');
            tocContent.classList.add('collapsed');
            tocHeader.classList.add('collapsed');
        }
    });
    
    // Handle TOC link clicks
    tocItems.forEach(item => {
        const link = item.querySelector('a');
        link.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Remove active class from all items
            tocItems.forEach(tocItem => tocItem.classList.remove('active'));
            
            // Add active class to clicked item
            item.classList.add('active');
            
            // Smooth scroll to target section
            const targetId = this.getAttribute('href').substring(1);
            const targetSection = document.getElementById(targetId);
            
            if (targetSection) {
                targetSection.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
                
                // Update URL hash
                history.pushState(null, null, '#' + targetId);
            }
        });
    });
};

export default tableOfContent;